import { c as _c } from "react/compiler-runtime";
import { BoldLeaf } from '@src/components/sco/RichMarkdownInput/components/leafs/BoldLeaf';
import { CodeLeaf } from '@src/components/sco/RichMarkdownInput/components/leafs/CodeLeaf';
import { ItalicLeaf } from '@src/components/sco/RichMarkdownInput/components/leafs/ItalicLeaf';
import { StrikethroughLeaf } from '@src/components/sco/RichMarkdownInput/components/leafs/StrikethroughLeaf';
import { UnderlineLeaf } from '@src/components/sco/RichMarkdownInput/components/leafs/UnderlineLeaf';
import React from 'react';
import { RenderLeafProps } from 'slate-react';
export const Leaf = props => {
  const $ = _c(13);
  if (props.leaf.bold) {
    let t0;
    if ($[0] !== props) {
      t0 = <BoldLeaf {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  if (props.leaf.italic) {
    let t0;
    if ($[2] !== props) {
      t0 = <ItalicLeaf {...props} />;
      $[2] = props;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    return t0;
  }
  if (props.leaf.underline) {
    let t0;
    if ($[4] !== props) {
      t0 = <UnderlineLeaf {...props} />;
      $[4] = props;
      $[5] = t0;
    } else {
      t0 = $[5];
    }
    return t0;
  }
  if (props.leaf.strikethrough) {
    let t0;
    if ($[6] !== props) {
      t0 = <StrikethroughLeaf {...props} />;
      $[6] = props;
      $[7] = t0;
    } else {
      t0 = $[7];
    }
    return t0;
  }
  if (props.leaf.code) {
    let t0;
    if ($[8] !== props) {
      t0 = <CodeLeaf {...props} />;
      $[8] = props;
      $[9] = t0;
    } else {
      t0 = $[9];
    }
    return t0;
  }
  let t0;
  if ($[10] !== props.attributes || $[11] !== props.children) {
    t0 = <span {...props.attributes}>{props.children}</span>;
    $[10] = props.attributes;
    $[11] = props.children;
    $[12] = t0;
  } else {
    t0 = $[12];
  }
  return t0;
};